import { ContactForm as ContactFormType } from "../../../sanity/lib/types/contactForm";
import { UnstyledLink } from "../link/unstyledLink";
import HardCodedContactForm from "./HardCodedContactForm";

export const ContactForm = ({ data }: { data: ContactFormType }) => {
    return (
        <section className="container pt-14 md:pt-19 pb-19 contact-form">
            <div className="mx-2.5 md:mx-5">
                <div className="grid grid-cols-12 gap-5">
                    <div className="col-span-12 md:col-span-6">
                        {data.title && (
                            <h2 className="m-headline-3 md:d-headline-1">{data.title}</h2>
                        )}
                    </div>
                </div>
                <div className="grid grid-cols-12 gap-5 mt-6 md:mt-12">
                    <div className="col-span-12 md:col-span-6 order-2 md:order-1">
                        {data.contactLinks && data.contactLinks.length > 0 && (
                            <div className="flex flex-col gap-4 mt-10 md:mt-0">
                                {data.contactLinks.map((link, index) => (
                                    <div key={index}>
                                        <UnstyledLink
                                            link={link}
                                            className="underline font-bold! lg:d-headline-3!"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="col-span-12 md:col-span-6 order-1 md:order-2 mt-10 md:mt-0">
                        <HardCodedContactForm />
                    </div>
                </div>
            </div>
        </section>
    );
};
